var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { ConfigureComponentBase } from '../configure-component-base';
import { AppConsts } from '../AppConsts';
import { ImageUrlHelper } from '../../main/workshop/diagram/utils/imageUrlHelper';
var ImageUploaderComponent = /** @class */ (function (_super) {
    __extends(ImageUploaderComponent, _super);
    function ImageUploaderComponent(injector, tokenService) {
        var _this = _super.call(this, injector) || this;
        _this.tokenService = tokenService;
        _this.imageIdChange = new EventEmitter();
        return _this;
    }
    ImageUploaderComponent.prototype.ngOnInit = function () {
        this.isDefaultImage = this.imageId === 'defaultImage';
        if (this.imageId) {
            this.imageUrl = ImageUrlHelper.buildImageUrl(this.imageId);
        }
        this.initUploader();
    };
    ImageUploaderComponent.prototype.initUploader = function () {
        var _this = this;
        this.imageUploader = this.createUploader('/ConfigureComponent/UploadImage', function (result) {
            _this.imageId = result.id;
            _this.isDefaultImage = _this.imageId === 'defaultImage';
            _this.imageUrl = ImageUrlHelper.buildImageUrl(result.id);
            _this.imageIdChange.emit(result.id);
        });
    };
    ImageUploaderComponent.prototype.deleteImage = function () {
        this.isDefaultImage = true;
        this.imageId = 'defaultImage';
        this.imageUrl = ImageUrlHelper.buildImageUrl('defaultImage');
        this.imageIdChange.emit('defaultImage');
    };
    ImageUploaderComponent.prototype.createUploader = function (url, success) {
        var _this = this;
        var uploader = new FileUploader({ url: AppConsts.remoteServiceBaseUrl + url });
        uploader.onBeforeUploadItem = function (__) {
            abp.ui.setBusy();
        };
        uploader.onAfterAddingFile = function (file) {
            file.withCredentials = false;
        };
        uploader.onSuccessItem = function (item, response) {
            var ajaxResponse = JSON.parse(response);
            if (ajaxResponse.success) {
                if (success) {
                    success(ajaxResponse.result);
                }
            }
            else {
                _this.message.error(ajaxResponse.error.message);
            }
            abp.ui.clearBusy();
        };
        var uploaderOptions = {};
        uploaderOptions.autoUpload = true;
        uploaderOptions.authToken = "Bearer " + this.tokenService.getToken();
        uploaderOptions.removeAfterUpload = true;
        var languageName = abp.localization.currentLanguage.name;
        uploaderOptions.headers = [{ name: '.AspNetCore.Culture', value: languageName }, { name: 'Accept-Language', value: languageName }];
        uploader.setOptions(uploaderOptions);
        return uploader;
    };
    __decorate([
        Input()
    ], ImageUploaderComponent.prototype, "imageId", void 0);
    __decorate([
        Input()
    ], ImageUploaderComponent.prototype, "showDelBtn", void 0);
    __decorate([
        Output()
    ], ImageUploaderComponent.prototype, "imageIdChange", void 0);
    ImageUploaderComponent = __decorate([
        Component({
            selector: 'fc-image-uploader',
            template: "<p class=\"fe-option-head\">{{lc(\"UploadImagePreview\")}}</p> <div class=\"mb-3\" style=\"width:240px;height:158px;position:relative;\"> <img width=\"240\" height=\"158\" crossorigin=\"anonymous\" *ngIf=\"imageUrl\" [src]=\"imageUrl\"> <span class=\"del-image\" (click)=\"deleteImage()\" *ngIf=\"imageUrl && showDelBtn && !isDefaultImage\"> </span> </div> <input type=\"file\" ng2FileSelect [uploader]=\"imageUploader\" required /> <p class=\"mt-3\">{{lc(\"UploadImageTipInfo\")}}</p>",
            styles: [".del-image { position: absolute; display: inline-block; width: 22px; height: 22px; font-size: 15px; border-radius: 50%; line-height: 18px; background: rgba(0, 0, 0, 0.2); text-align: center; color: #fafafa; top: 5px; right: 10px; } .del-image:hover{ background: rgba(0, 0, 0, 0.3); } .del-image:after { content: \"x\"; cursor: pointer; } "]
        })
    ], ImageUploaderComponent);
    return ImageUploaderComponent;
}(ConfigureComponentBase));
export { ImageUploaderComponent };
